// extracted by mini-css-extract-plugin
export default {"clientReviewContent":"ClientReviewContent_clientReviewContent__a8aVi","clientReviews":"ClientReviewContent_clientReviews__-Z9sR"};